import { FormJourneyQuestionType, LeadForm } from "@plura/shared/types";

export const getCurrentResponseScore = (response: { [key: string]: string | number }, leadForm: LeadForm): number | null => {
  let score = 0
  const allowedBlockTypes: FormJourneyQuestionType[] = ['DROPDOWN', 'MULTIPLE_CHOICE', 'OPTION_SCALE', 'RATING', 'RANKING', 'STATEMENT', 'NPS']
  const allowedJourneyItems = leadForm.journeyItems?.filter(item => allowedBlockTypes.includes(item.type)) ?? []
  const eligibleAnswers = Object.keys(response).filter(key => allowedJourneyItems.find(item => item.blockId === key))
  const scoringJourneyItemsExists = !!eligibleAnswers.find(key => allowedJourneyItems.find(item => item.blockId === key)?.scoreValues)

  if (!scoringJourneyItemsExists) return null

  eligibleAnswers.forEach(key => {
    const journeyItem = allowedJourneyItems.find(item => item.blockId === key)
    const answer = response[key]

    if (journeyItem?.scoreValues) {
      let scoredAnswer: number | null = null;

      if (journeyItem.type === 'DROPDOWN' || journeyItem.type === 'MULTIPLE_CHOICE') {
        // For dropdown/multiple choice, scoreValues is an object { optionId: score }
        if (typeof journeyItem.scoreValues === 'object' && !Array.isArray(journeyItem.scoreValues)) {
          if (journeyItem.type === 'MULTIPLE_CHOICE') {
            // For multiple choice, answer could be a single option or comma-separated multiple options
            const selectedOptions = String(answer).split(',').map(option => option.trim()).filter(option => option !== '');
            let totalScore = 0;

            selectedOptions.forEach(optionId => {
              if (journeyItem.scoreValues && typeof journeyItem.scoreValues === 'object' && !Array.isArray(journeyItem.scoreValues)) {
                const optionScore = journeyItem.scoreValues[optionId];
                if (typeof optionScore === 'number') {
                  totalScore += optionScore;
                }
              }
            });

            scoredAnswer = totalScore;
          } else {
            // For dropdown, answer should be a single option ID
            scoredAnswer = journeyItem.scoreValues[answer] ?? null;
          }
        }
      } else if (journeyItem.type === 'OPTION_SCALE' || journeyItem.type === 'RATING' || journeyItem.type === 'NPS') {
        // For option scale/rating, scoreValues is an array [score1, score2, ...]
        if (Array.isArray(journeyItem.scoreValues)) {
          if (journeyItem.type === 'RATING') {
            // For ratings, answer is 1-based (1,2,3,4,5) so convert to 0-based index
            const answerIndex = Number(answer) - 1;
            scoredAnswer = journeyItem.scoreValues[answerIndex] ?? null;
          } else {
            // For option scale, use minRange to convert to 0-based index
            const answerIndex = Number(answer) - (journeyItem.minRange ?? 1);
            scoredAnswer = journeyItem.scoreValues[answerIndex] ?? null;
          }
        }
      } else if (journeyItem.type === 'STATEMENT') {
        // For statements, scoreValues is an object { yes: score, no: score }
        // But answers come in as "Yes"/"No" (capitalized), so we need to convert to lowercase
        if (typeof journeyItem.scoreValues === 'object' && !Array.isArray(journeyItem.scoreValues)) {
          const normalizedAnswer = String(answer).toLowerCase();
          scoredAnswer = journeyItem.scoreValues[normalizedAnswer] ?? null;
        }
      }

      if (scoredAnswer !== null && typeof scoredAnswer === 'number') {
        score += scoredAnswer
      }
    }
  })

  return score
};